import {EntityFormGeneralDataSection, FormStepper} from "base/component/form";
import {
    TanqueFormCaracteristicasSection,
    TanqueFormGeneralDataFields,
    TanqueFormLocationFields,
} from ".";
import Box from "@mui/material/Box";

const TanqueCreationForm = ({onSubmit, onCancel = null}) => {
    const steps = ["Datos xerais", "Características"];

    const stepComponents = [
        <EntityFormGeneralDataSection
            fields={<TanqueFormGeneralDataFields creation={true} />}
            location={<TanqueFormLocationFields isCreationForm={true} />}
        />,
        <TanqueFormCaracteristicasSection />,
    ];
    return (
        <Box component="form" width="100%" mt={4}>
            <FormStepper
                onSubmit={onSubmit}
                onCancel={onCancel}
                steps={steps}
                stepComponents={stepComponents}
            />
        </Box>
    );
};

export default TanqueCreationForm;
